// extracted by mini-css-extract-plugin
export var label = "_hs-0";
export var treatmentCard = "_hs-1";